'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'croissant';
var width = 512;
var height = 512;
var aliases = [129360];
var unicode = 'f7f6';
var svgPathData = 'M61.2 169c24.1-46 61.9-83.7 107.9-107.8l110 202.2-15.6 15.6L61.2 169zM190.4 0C100.9 30.3 30.2 100.9 0 190.4l14.3 7.8C5 226.4 0 256.6 0 288c0 49.4 12.4 95.9 34.3 136.5c7.6 14.1 16.3 27.5 26.1 40l.2 .3 23.8-18.5c26.9 29 60.5 51.7 98.2 65.7L224 480l-16-96 0-33.8 35.3-27.5L272 338.4 338.4 272l-15.6-28.7L350.2 208l33.8 0 96 16 32-41.3c-14.1-37.8-36.8-71.3-65.7-98.2l18.5-23.8-.3-.2c-12.6-9.7-25.9-18.5-40-26.1C383.9 12.4 337.4 0 288 0c-31.4 0-61.6 5-89.8 14.3L190.4 0zM416.7 122.6c14.6 14.2 27.2 30.5 37.2 48.4l-62-10.3L388 160l-.4 0 29.1-37.4zM160 387.6l0 .4 .7 3.9 10.3 62c-17.9-10-34.3-22.6-48.4-37.2L160 387.6zM48 288c0-23 3.2-45.3 9.3-66.4l140 76.2L72.9 394.5C56.9 362.4 48 326.3 48 288zM394.5 72.9L297.7 197.3l-76.1-140C242.7 51.2 265 48 288 48c38.3 0 74.4 8.9 106.5 24.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCroissant = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;